import React from "react";

import { Avatar, CardHeader } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import {
	formatContactDisplayName,
	getContactAvatarFallback
} from "../../utils/formatContactDisplayName";

const TicketInfo = ({ contact, ticket, onClick }) => {
	const contactDisplayName = formatContactDisplayName(contact);
	const subheaderParts = [];

	if (ticket?.user?.name) {
		subheaderParts.push(
			`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
		);
	}

	if (ticket?.description) {
		subheaderParts.push(ticket.description);
	}

	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={
				<Avatar src={contact.profilePicUrl} alt="contact_image">
					{getContactAvatarFallback(contact)}
				</Avatar>
			}
			title={`${contactDisplayName} #${ticket.id}`}
			subheader={subheaderParts.join(" • ")}
		/>
	);
};

export default TicketInfo;
